import { orderBy } from 'lodash-es';
import dayjs from 'dayjs';

function handleArrayMapByKey(andkey, key, arr = []) {
  const record = {};
  const andRecord = {};
  arr.forEach(item => {
    if (item.androidType === '1') {
      andRecord[item[andkey]] = item;
    } else {
      record[item[key]] = item;
    }
  });
  return {
    record,
    andRecord,
  };
}

/**
 *
 * @param {*} soft
 * @returns
 */
function handleSoftfilter(soft) {
  if (soft && soft.androidType !== '1' && soft.canUninst) {
    // if (soft && soft.androidType !== '1') {
    if (
      !(
        soft.displayName === '' ||
        // soft.SoftID === '"L80050"' ||
        // soft.softGUID === 'Lenovo SLBrowser' ||
        // soft.displayName.indexOf('联想浏览器') > -1 ||
        soft.softGUID === 'Microsoft Edge' ||
        soft.SoftID === '"26342"' ||
        soft.displayName.indexOf('microsoft edge') > -1 ||
        soft.displayName.indexOf('Edge') > -1 ||
        (soft.displayName &&
          (soft.displayName.replace(/\s+/g, '').indexOf('联想软件商店') > -1 ||
            soft.displayName.replace(/\s+/g, '').indexOf('联想应用商店') > -1)) ||
        soft.softGUID === 'LenovoAppStore_is1' ||
        soft.softID === 'L100072' ||
        soft.displayName.indexOf('联想电脑管家') > -1 ||
        soft.softGUID === '{A9861883-31C5-4324-BD9A-DC9527EEB675}_is1'
      )
    ) {
      return soft;
    }
  }
  return null;
}
export default {
  /**
   *
   * @param {*} arr  传入的软件列表
   * @param {*} params  排序类型
   * @returns  返回排序成功的软件列表
   */
  handleOrderBy(arr, params) {
    if (params === 'time') {
      return orderBy(arr, ['sortTime1', 'sortSize', 'displayName'], ['desc']);
    }
    return orderBy(arr, ['sortSize', 'sortTime1', 'displayName'], ['desc']);
  },
  /**
   *
   * @param {*} installedSoft 将传入的已安装软件列表
   * @returns   // 拆分成pc、安卓 并返回
   */

  handleInstallSoftByType(installedSoft) {
    const andInstalled = [];
    const pcInstalled = [];
    installedSoft.forEach(soft => {
      if (soft && soft.androidType === '1') {
        andInstalled.push(soft);
      }

      // soft.softGUID === 'LEmu' ||
      // soft.displayName.indexOf('联想应用融合引擎') > -1 ||
      const tempSoft = handleSoftfilter(soft);
      if (tempSoft) {
        pcInstalled.push(tempSoft);
      }
    });
    return {
      pcInstalled,
      andInstalled,
    };
  },

  /**
   * @param {*} installedSoft 将传入的已安装软件列表
   * @returns   // 拆分成pc、安卓 并返回
   * 不过滤联想产品的本地应用分类
   */

  handleInstallSoftNoFlilter(installedSoft) {
    const andInstalled = [];
    const pcInstalled = [];
    installedSoft.forEach(soft => {
      if (soft && soft.androidType === '1') {
        andInstalled.push(soft);
      } else {
        pcInstalled.push(soft);
      }
    });
    return {
      pcInstalled,
      andInstalled,
    };
  },

  /**
   *
   * @param {*} installedSoftInit
   * @param {*} mixBatchDetails
   * @returns  本地不能打开的软件
   */
  handleDisableUninstallSoft(installedSoftInit, mixBatchDetails) {
    const cantOpenSoft = [];
    const allSoft = [];
    installedSoftInit.forEach(soft => {
      const target =
        mixBatchDetails.find(item => item.softID === soft.SoftID && item.androidType !== '1') || {};
      if (soft && soft.androidType !== '1' && soft.canUninst && !soft.MainExePath) {
        cantOpenSoft.push({
          softGUID: soft.softGUID,
          softID: soft.SoftID,
          softName: soft.displayName,
          version: soft.displayVersion,
          category: target.myTags,
        });
      }
      allSoft.push({
        softGUID: soft.softGUID,
        softID: soft.SoftID,
        softName: soft.displayName,
        version: soft.displayVersion,
        category: target.myTags,
      });
    });
    return {
      allSoft,
      cantOpenSoft,
    };
  },
  /**
   *
   * @param {*} mixBatchDetails  软件分类数据
   * @param {*} pcInstalled pc软件
   * @param {*} tempResidualList 临时残留列表
   * @param {*} notOftenUsedSofts 不常用软件
   * @param {*} notOftenUsedSoftsIcon 不常用软件图标
   * @returns
   */
  handlePCSoftByCategory(
    mixBatchDetails = [],
    pcInstalled = [],
    tempResidualList = [],
    notOftenUsedSofts = [],
    notOftenUsedSoftsIcon,
  ) {
    const recordObj = {};

    pcInstalled.forEach((item, index) => {
      mixBatchDetails.forEach(j => {
        if (item.SoftID === j.softID) {
          pcInstalled[index].downloadCount = j.downloadCount;
          pcInstalled[index].version = j.version;
          pcInstalled[index].SoftName = j.softName;
        }
      });
    });

    // 查找出刚刚卸载且不在pc安装列表里面的软件（ps:需要找出这些软件是因为 刚刚卸载的软件也需要显示分类信息）
    const tempResidualNotInPcInstalled = tempResidualList.filter(
      item => !pcInstalled.find(soft => item.softGUID === soft.softGUID),
    );
    const softMapFromMixBatchDetails = handleArrayMapByKey(
      'packageName',
      'softID',
      mixBatchDetails,
    );

    const { record } = softMapFromMixBatchDetails;
    [...pcInstalled, ...tempResidualNotInPcInstalled].forEach(soft => {
      const categoryInfo = record[soft.SoftID] || {};

      const updateSoft = {
        ...soft,
        title: categoryInfo.title,
        userGrade: categoryInfo.userGrade,
        logoFile: categoryInfo.logoFile || soft.logoFile,
        sortTime: soft.sortTime,
        onStore: soft?.SoftID ? 1 : 0,
      };
      if (categoryInfo.myTags) {
        categoryInfo.myTags.forEach(item => {
          if (recordObj[item]) {
            recordObj[item].push(updateSoft);
          } else {
            recordObj[item] = [updateSoft];
          }
        });
      } else if (recordObj['9999']) {
        recordObj['9999'] = [...recordObj['9999'], updateSoft];
      } else {
        recordObj['9999'] = [updateSoft];
      }
    });
    recordObj.all_zw = Object.keys(recordObj).reduce((result, key) => {
      const temp = [];
      recordObj[key].forEach(arr => {
        if (!result.find(item => item.SoftID === arr.SoftID)) {
          temp.push(arr);
        }
      });
      return [...result, ...temp];
    }, []);
    // 不常用软件
    recordObj.not_often_used_softs = notOftenUsedSofts.map(item => ({
      ...item,
      logoFile:
        (notOftenUsedSoftsIcon &&
          notOftenUsedSoftsIcon[item.softID] &&
          notOftenUsedSoftsIcon[item.softID].logoFile) ||
        item.logoFile,
    }));

    return recordObj;
  },
  /**
   *
   * @param {*} mixBatchDetails  软件分类数据
   * @param {*} andInstalled 安卓软件
   * @param {*} tempResidualList 临时残留列表
   * @returns
   */
  handleANDSoftByCategory(mixBatchDetails = [], andInstalled = [], tempResidualList = []) {
    const recordObj = {};
    // // 查找出刚刚卸载且不在pc安装列表里面的软件（ps:需要找出这些软件是因为 刚刚卸载的软件也需要显示分类信息）
    // const tempResidualNotInPcInstalled = tempResidualList.filter(
    //   item => !pcInstalled.find(soft => item.softGUID === soft.softGUID),
    // );
    andInstalled.forEach((item, index) => {
      mixBatchDetails.forEach(j => {
        if (item.packageName === j.packageName) {
          andInstalled[index].downloadCount = j.downloadCount;
        }
      });
    });

    const softMapFromMixBatchDetails = handleArrayMapByKey(
      'packageName',
      'softID',
      mixBatchDetails,
    );
    const { andRecord } = softMapFromMixBatchDetails;
    [...andInstalled].forEach(soft => {
      const categoryInfo = andRecord[soft.packageName] || {};
      const updateSoft = {
        ...soft,
        title: categoryInfo.title,
        userGrade: categoryInfo.userGrade,
        logoFile: categoryInfo.logoFile || soft.logoFile,
      };
      if (categoryInfo.myTags) {
        categoryInfo.myTags.forEach(item => {
          if (recordObj[item]) {
            recordObj[item].push(updateSoft);
          } else {
            recordObj[item] = [updateSoft];
          }
        });
      } else if (recordObj['9999']) {
        recordObj['9999'] = [...recordObj['9999'], updateSoft];
      } else {
        recordObj['9999'] = [updateSoft];
      }
    });
    recordObj.all_zw = Object.keys(recordObj).reduce((result, key) => {
      const temp = [];
      recordObj[key].forEach(arr => {
        if (!result.find(item => item.packageName === arr.packageName)) {
          temp.push(arr);
        }
      });
      return [...result, ...temp];
    }, []);

    return recordObj;
  },
  handleNotOftenUsedSoft(list = []) {
    // 过滤屏蔽特定的软件;
    return list.filter(soft => handleSoftfilter(soft));
    // return list
    //   .filter(
    //     soft =>
    //       !soft.usedTime ||
    //       +new Date(dayjs(soft.usedTime).format('YYYY-MM-DD')) <=
    //         +new Date(
    //           dayjs()
    //             .subtract(3, 'month')
    //             .format('YYYY-MM-DD HH:mm:ss'),
    //         ),
    //   )
    //   .filter(soft => handleSoftfilter(soft, true));
  },

  // 针对8.3的临时改动
  handleFilterSoft(soft) {
    if (
      (soft.SoftID ?? soft.softID) === '2' ||
      (soft.SoftID ?? soft.softID) === 'L104026' ||
      (soft.SoftID ?? soft.softID) === 'L100593' ||
      (soft.SoftID ?? soft.softID) === '1211' ||
      (soft.SoftID ?? soft.softID) === 'L100173' ||
      (soft.SoftID ?? soft.softID) === '2081' ||
      (soft.SoftID ?? soft.softID) === 'L100987' ||
      (soft.SoftID ?? soft.softID) === 'L104075' ||
      (soft.SoftID ?? soft.softID) === '56573' ||
      (soft.SoftID ?? soft.softID) === '21716' ||
      (soft.SoftID ?? soft.softID) === '1023' ||
      (soft.SoftID ?? soft.softID) === '323' ||
      (soft.SoftID ?? soft.softID) === 'L101930'
    ) {
      return false;
    } else {
      return true;
    }
  },
};
